import { useRef, useState } from 'react';

export function useToggleDropdown<T = HTMLDivElement>() {
  const [isOpen, setOpen] = useState(false);

  const ref = useRef<T>(null);

  return { ref, isOpen, setOpen };
}
